import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { ProductRegistration } from '@app/components/apps/ProductRegistration/ProductRegistration';

const RegisterProductPage = () => {
  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Register Product');
  const navigate = useNavigate();

  const categoryId = Number(localStorage.getItem('selected_category_id')) || 0;
  const categoryName = localStorage.getItem('selected_category_name') || '';

  const routes = [
    { path: 'pr-categories', breadcrumbName: 'Product Registrations' },
    { path: 'product-registrations', breadcrumbName: categoryName },
    { path: '/register-product', breadcrumbName: 'Register Product' },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, categoryId]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ProductRegistration
          editable={false}
          pageTitle={'Register Product'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default RegisterProductPage;
